// GENERATED FILE - DO NOT EDIT.
// Source: backend/tests/snapshots/openapi_contract.json, via `npm run gen:api` (orval).
// Regenerate after the API contract changes; `npm run check:gen-api` fails when this is stale.
import * as zod from 'zod';
import { ValidationError } from './validationError.zod.ts';

export const HTTPValidationError = zod.object({
  "detail": zod.array(ValidationError).optional()
});

export type HTTPValidationError = zod.input<typeof HTTPValidationError>;
export type HTTPValidationErrorOutput = zod.output<typeof HTTPValidationError>;
